import { Table } from "@/entities/tables";
import { Order } from "../../../entities/orders-pickup-delivery/models/types";
import { http } from "../../../shared/api/http";

export async function updateTableStatus(id:any,data:any): Promise<Table> {
  const res = await http.put(`/waiter/tables/${id}/status`,data);
  return res.data;
}